module.exports = __webpack_public_path__ + "static/media/heywow-semibold-webfont.d53e21f2.woff";